import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';

function heure(): string {
  return new Date().toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
}

export const logInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const debut = performance.now();
  const page = router.routerState.snapshot.url || '/';

  return next(req).pipe(
    tap({
      next: (event: any) => {
        if (event.status !== undefined) {
          const duree = Math.round(performance.now() - debut);
          console.log(
            `%c[API] %c${heure()} %c${req.method} %c${req.urlWithParams}%c — ${duree}ms — HTTP ${event.status} — page: ${page}`,
            'color: #888; font-weight: bold',
            'color: #aaa',
            'color: #4fc3f7; font-weight: bold',
            'color: inherit',
            'color: #888'
          );
        }
      },
      error: (err) => {
        const duree = Math.round(performance.now() - debut);
        console.error(
          `[API] ${heure()} ${req.method} ${req.urlWithParams} — ${duree}ms — HTTP ${err.status ?? '?'} — page: ${page}`
        );
      },
    }),
  );
};
